export const tabs = {
	summary: "AgentSummary",
	personalInfo: "PersonalInfo",
	bgChecks: "BackgroundChecks",
	drugTests: "DrugTests",
	training: "Training",
	trainerCert: "TrainerCertification",
	documentation: "Documentation",
	complaints: "Complaints",
	eves: "EnrollmentValidations",
	idValidation: "IdValidation",
	repDisciplines: "Discipline",
	onboardingAudits: "OnboardingAudits",
	fieldAudits: "FieldAudits",
	stateSpecificTraining: "StateSpecificTraining",
	repTraining: "RepTraining",
	agentSummary: "AgentSummary",
	onboardingStates: "OnboardingStates",
} as const;

export type RepPortalTabs = (typeof tabs)[keyof typeof tabs];

export const modals = {
	deactivationForm: "DeactivationForm",
	customerActionForm: "CustomerActionForm",
} as const;

export type dynamicEditorPageName = (typeof tabs)[keyof typeof tabs] | (typeof modals)[keyof typeof modals];
